import cookie from 'js-cookie'
import * as Lockr from 'lockr'
import { COOKIE_KEYS } from './auth/cookies'

export function getCookie(name: string) {
  return cookie.get(name)
}

export function setCookie(name: string, value: string, options: Object = {}) {
  return cookie.set(name, value, options)
}

export function removeCookie(name: string, options: Object = {}) {
  return cookie.remove(name, options)
}

export function getLocalStorage(name: string) {
  return Lockr.get(name)
}

export function setLocalStorage(name: string, value: string) {
  return Lockr.set(name, value)
}

export function removeLocalStorage(name: string) {
  return Lockr.rm(name)
}

export const setAccessToken = (token: string) => {
  setCookie(COOKIE_KEYS.TOKEN, token, { secure: true, expires: 30 })
}

export const setRefreshToken = (token: string) => {
  setCookie(COOKIE_KEYS.REFRESH_TOKEN, token, { secure: true, expires: 30 })
}
